<template lang="pug">
  base-node(:data="data" :nodeType="IQ_TOOL_ACTION_TYPE_WORKFLOW")
    template(#icon)
      i.iq-ico-building-kit-workflow
</template>

<script>
import BaseNode from './BaseNode.vue';
import { IQ_TOOL_ACTION_TYPE_WORKFLOW } from '@/constants/iqtool';

export default {
  name: 'DiagramWorkflowNode',
  components: {
    BaseNode,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      IQ_TOOL_ACTION_TYPE_WORKFLOW,
    };
  },
};
</script>

<style scoped>
  .workflow-node-wrapper {
    border-color: #927ACA;
  }
  .iq-ico-building-kit-workflow::before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23927ACA' d='M256 128l0-32L64 96l0 128 416 0 32 0 0 32 0 192 0 32-32 0-64 0 0 32-128 0 0-128 128 0 0 32 32 0 0-128L32 288 0 288l0-32L0 64 0 32l32 0 224 0 0-32 24 0 72 64-72 64-24 0zM128 384l0 32 32 0 0-32 24 0 72 64-72 64-24 0 0-32-32 0 0 32L0 512 0 384l128 0zM512 0l0 128-128 0L384 0 512 0z'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    width: 10px;
    height: 10px;
  }
</style>